module.exports = __webpack_public_path__ + "static/img/IMG_20170905_182731.6436da0d.jpg";